import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { VehiclesComponent } from './veh.component';
import { VehFiltersComponent } from './vehicles-filters/veh-filters.component';

import { ListService } from '../list.service';

import { AngularMaterialModule } from '../angular-material.module';
import { StripHtmlPipe2 } from '../pipes/stripHTMLpipe2';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule
  ],
  providers: [
    VehFiltersComponent,
    StripHtmlPipe2,
    ListService
  ],
  declarations: [
    VehiclesComponent,
    VehFiltersComponent,
    StripHtmlPipe2
  ],
  exports: [
    VehiclesComponent,
    StripHtmlPipe2
  ]
})

export class VehiclesModule { }
